import React, { useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step6 = ({ setStep, setFormdata, formData, setStep6Status }) => {
  const dateString = formData?.dob;
  const dateTime = new Date(dateString);
  const month = dateString ? dateTime.getMonth() + 1 : "";
  const date = dateString ? dateTime.getDate() : "";
  // const year = dateString ? dateTime.getFullYear() : "";

  const [months, setMonths] = useState(month || "");
  const [dates, setDates] = useState(month || "");

  const [dobError, setDobError] = useState(false); // Error state for DOB validation

  // const currentYear = new Date().getFullYear();

  const HandleDate = (type, value) => {
    let updatedMonth = months;
    let updatedDate = dates;
    // let updatedYear = year;

    // console.log(type,value)

    if (type === "month") {
      // alert(value)
      updatedMonth = value;
      setMonths(Number(value));

    } else if (type === "date") {
      // alert(value+"s")
      updatedDate = value;
      setDates(Number(value))
    }
    //  else if (type === "year") {
    //   updatedYear = value;
    // }

    // const updatedDob = `${updatedYear}-${String(updatedMonth).padStart(2, "0")}-${String(updatedDate).padStart(2, "0")}`;

    // console.log("updated",updatedMonth, updatedDate)

    const updatedDob = `${String(updatedMonth).padStart(2, "0")}-${String(updatedDate).padStart(2, "0")}`;
// console.log("updatedDob",updatedDob)

    setFormdata((prevState) => ({
      ...prevState,
      dob: updatedDob, // Update the dob field
    }));
  };

  // console.log(month)
  // Handle Next button click with validation
  const handleNext = () => {

    if (!months || !dates) {
      setDobError(true); // Show error if any field is missing
    } else {
      setDobError(false); // Clear the error
      setStep(7); // Proceed to the next step
      setStep6Status(true); // Mark step 6 as completed
    }
  };

  return (
    <>
      <div class="top_logo_block">
        <div class="logo">
          <a href="">
            <img src={logo} alt="" />
          </a>
        </div>
      </div>

      <div class="step_body">
        <div class="step_form">
          <div class="form_block box_width_md_one">
            <h1>Your Date of Birth</h1>
            <div class="input_fields">
              <div class="select_block">
                <select
                  name=""
                  id=""
                  onChange={(e) => HandleDate("month", e.target.value)}
                >
                  <option hidden disabled value="0" selected>Select Month</option>
                  <option value="1" selected={1 == months}>January</option>
                  <option value="2" selected={2 == months}>February</option>
                  <option value="3" selected={3 == months}>March</option>
                  <option value="4" selected={4 == months}>April</option>
                  <option value="5" selected={5 == months}>May</option>
                  <option value="6" selected={6 == months}>June</option>
                  <option value="7" selected={7 == months}>July</option>
                  <option value="8" selected={8 == months}>August</option>
                  <option value="9" selected={9 == months}>September</option>
                  <option value="10" selected={10 == months}>October</option>
                  <option value="11" selected={11 == months}>November</option>
                  <option value="12" selected={12 == months}>December</option>
                </select>
              </div>

              <div class="select_block">
                <select
                  name="day"
                  key={months}
                  id="daySelect"
                  onChange={(e) => HandleDate("date", e.target.value)}
                >
                  <option hidden disabled value="0" selected>Select Date</option>
                  {(months == 1 || months == 3 || months == 5 || months == 7 || months == 8 || months == 10 || months == 12)
                    ? [...Array(31)].map((_, index) => (
                        <option key={index} value={index + 1} selected={date == index + 1}>
                          {index + 1}
                        </option>
                      ))
                    : months == 2
                    ? [...Array(29)].map((_, index) => (
                        <option key={index} value={index + 1} selected={date == index + 1}>
                          {index + 1}
                        </option>
                      ))
                    : [...Array(30)].map((_, index) => (
                        <option key={index} value={index + 1} selected={date == index + 1}>
                          {index + 1}
                        </option>
                      ))}
                </select>
              </div>

              {/* <div class="select_block">
                <select
                  name="year"
                  id="yearSelect"
                  onChange={(e) => HandleDate("year", e.target.value)}
                >
                  <option hidden disabled value="0" selected>Select Year</option>
                  {Array.from({ length: currentYear - 1960 + 1 }, (_, i) => (
                    <option key={i} value={1960 + i} selected={year == 1960 + i}>
                      {1960 + i}
                    </option>
                  ))}
                </select>
              </div> */}

              {dobError && (
                <p style={{ color: "red" }}>Please select a valid month and date.</p>
              )}
            </div>
          </div>

          <div class="btn_block">
            <a onClick={() => setStep(5)}>
              <img src={prev_arrow} alt="" /> <span>Prev</span>
            </a>
            <a onClick={handleNext} class="nxt_btn">
              <span>Next</span> <img src={next_arrow} alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step6;